export const fmtNumber = (n: number) => Number(n).toLocaleString('uk-UA');

/** Today is computed once per page mount — granularity is "day", not "ms". */
const startOfToday = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

export const relDayLabel = (iso: string) => {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return '';
  const today = startOfToday();
  const target = new Date(y, m - 1, d);
  const diff = Math.round((today.getTime() - target.getTime()) / 86400000);
  if (diff <= 0) return 'сьогодні';
  if (diff === 1) return 'вчора';
  if (diff < 7) return `${diff} дн. тому`;
  const dd = String(d).padStart(2, '0');
  const mm = String(m).padStart(2, '0');
  // Drop the year for the current calendar year ("12.06") — keep it
  // when the timestamp slid into a previous year ("12.06.2025") so the
  // reader doesn't mistake an old update for a recent one.
  if (y === today.getFullYear()) return `${dd}.${mm}`;
  return `${dd}.${mm}.${y}`;
};
